<template>
  <b-tab>
    <template #title>
      <feather-icon
          icon="SlidersIcon"
          size="21"
      />
      <strong>
        Eredmények
      </strong>
    </template>

    <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
    >
      <b-row>
        <b-col cols="12">
          <div v-for="result in results">
            <p class="mb-0"><strong>{{ result.title }}</strong></p>
            <div class="progress">
              <div class="progress-bar" role="progressbar" :style="{width: result.percent+'%'}" :aria-valuenow="result.percent" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <p>{{ result.percent }}%</p>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-tab>
</template>

<script>
import {
  BTab,
  BBadge,
  BRow,
  BCol,
  BButton,
  BFormFile,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupText,
  BOverlay,
  BForm,
  BLink,
} from 'bootstrap-vue'


export default {
  components: {
    BTab,
    BBadge,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupText,
    BOverlay,
    BForm,
    BLink,
  },
  props: {
    results: {
      required: true
    },
  },
  data() {
    return {
      loading: false,
    }
  }
}
</script>

<style scoped>

</style>
